import intersection from 'lodash/intersection';
import { ACTIONS } from 'a/pictureThis/data/constants';

export const initialState = {
  storyTag: 'setting',
  layoutInfo: {},
  isTouching: false,
  shakeTrigger: false,
  storyElements: [
    'setting',
    'character',
    'character 1',
    'character 2',
    'problem',
    'problem 1',
    'problem 2',
    'solution',
    'solution 1',
    'solution 2',
  ],
};

const dropzone = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.SELECT_LEVEL:
      return initialState;

    case ACTIONS.ADVANCE_CONTENT:
      return {
        ...state,
        storyTag: 'setting',
      };

    case ACTIONS.UPDATE_DROPZONE_LAYOUT:
      if (payload) {
        return {
          ...state,
          layoutInfo: payload,
        };
      }
      return state;
    case ACTIONS.SET_DROPZONE_IS_TOUCHING:
      return {
        ...state,
        isTouching: payload,
      };
    case ACTIONS.NEXT_STORY_ELEMENT:
      return {
        ...state,
        storyTag: nextStoryTag(state.storyTag, state.storyElements),
      };
    case ACTIONS.SHAKE_DROPZONE:
      return {
        ...state,
        shakeTrigger: !state.shakeTrigger,
      };
    case ACTIONS.CREATE_VIEW_MODEL_FROM_CONTENT:
      return {
        ...state,
        storyElements: intersection(initialState.storyElements, payload.uniqueElements),
      };
    default:
      return state;
  }
};

export default dropzone;

export const nextStoryTag = (currentTag, storyElements) => (
  storyElements[(storyElements.indexOf(currentTag) + 1) % storyElements.length]
);

// selectors

export const getLayout = state => state.layoutInfo;

export const isTouching = state => state.isTouching;

export const getStoryTag = state => state.storyTag;

export const getShakeTrigger = state => state.shakeTrigger;
